/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component, useState } from 'react' // eslint-disable-line

import { Drawer, Button, Form, Spin, Input, message } from 'antd'

import { machineAction } from '../../action/machine'

// import { Machine } from '../../business/define'
import { ViewerStyles, EditorStyles } from './styles'

const FIELDS_LIST = [
  'price',
  'trial_times',
]
const FIELDS_META: any = {
  price: '价格',
  trial_times: '试用次数',
}

interface Props {
  text: string
  record: any
  onLoadChange?: Function
}

const MachineFormInner = (props: any) => {
  const { getFieldDecorator } = props.form

  const record = props['record']
  const onSubmitMachine = (e: Event) => {
    e.preventDefault()
    props.form.validateFields((err: any, values: any) => {
      if (err) {
        message.warning(err.message)
        console.log(err)
        console.log('Received values of form: ', values)
        return
      }
      const targetForm: any = {}
      let hasChange = false
      FIELDS_LIST.forEach((key) => {
        if (values[key] !== '' && !isNaN(values[key])) {
          hasChange = true
          targetForm[key] = values[key]
        }
      })
      if (!hasChange) {
        message.warning('Nothing Change')
        return
      }

      props.onSubmitMachine(targetForm)
    })
  }

  return <Form layout="vertical" css={EditorStyles['edit-form']} onSubmit={onSubmitMachine}>
    <Form.Item label="机器id" css={EditorStyles["edit-label-title"]}>
      <span className="ant-form-text">{props.record['machine_id']}</span>
    </Form.Item>
    {
      FIELDS_LIST.map((item) => {
        return (
          <Form.Item
            key={item}
            label={
              <span css={EditorStyles['edit-label']}>
                <span className="label-title">{FIELDS_META[item]}:</span>
                <span css={EditorStyles['edit-label-hint']}>{item}</span>
              </span>
            }
          >
            <div css={EditorStyles['edit-hint-line']}>
              {
                getFieldDecorator(item, {
                  initialValue: record[item],
                  rules: [
                    { required: false, message: `请填入正确的${FIELDS_META[item]}` },
                  ],
                })(
                  <Input placeholder={`Input ${item}`} />
                )
              }
            </div>
          </Form.Item>
        )
      })
    }
    <Form.Item>
      <Button type="primary" htmlType="submit">保存</Button>
    </Form.Item>
  </Form>
}

const MachineForm = Form.create({ name: 'machine_attribute' })(MachineFormInner)

export default (props: Props) => {
  const [visible, onVisibleChange] = useState(false)
  const [loading, onLoadChange] = useState(false)

  // const [attribute, onAttributeChange] = useState<any>(props.attribute)
  // const [editAttribute, onEditAttributeChange] = useState<any>(props.attribute)
  const reload = () => {
    if (props.onLoadChange) {
      props.onLoadChange()
    }
  }

  const onSubmitMachine = (formData: any) => {
    machineAction.editMachine(props.record['machine_id'], formData)
      .then(responseData => {
        onLoadChange(false)
        reload()
        // onAttributeChange(formData)
      })
      .catch((err) => {
        onLoadChange(false)
        message.warning(err.message)
      })
  }

  return (
    <div css={EditorStyles['edit-pane']}>
      <Button onClick={onVisibleChange} size="small">{props.text}</Button>
      <Drawer
        title="编辑机器信息"
        width={420}
        visible={visible}
        onClose={() => {
          onVisibleChange(false)
        }}
      >
        <div css={ViewerStyles['drawer-container']}>
          <Spin spinning={loading}>
            <MachineForm
              record={props.record}
              onSubmitMachine={onSubmitMachine}
            />
          </Spin>
        </div>
      </Drawer>
    </div>
  )
}